import { computed, Injectable, signal, Signal, WritableSignal } from '@angular/core';
import { EventsService } from '../../events/events.service';
import { firstValueFrom, lastValueFrom } from 'rxjs';
import { LiveCallModel } from './models/live-call.model';
import { WallboardService as ApiWallboardService } from '../../api/services/wallboard.service';
import { LiveCallViewModel } from './models/live-call-view.model';

@Injectable({ providedIn: 'root' })
export class WallboardService {
  private _currentQueue: WritableSignal<string> = signal('');
  currentQueue: Signal<string> = this._currentQueue.asReadonly();
  liveCalls: WritableSignal<LiveCallModel[]> = signal<LiveCallModel[]>([]);

  waitingCalls = computed(() => this.getWaitingCallsForQueue(this.currentQueue()));
  connectedCalls = computed(() => this.getConnectedCallsForQueue(this.currentQueue()));

  constructor(
    private readonly eventService: EventsService,
    private readonly apiWallboardService: ApiWallboardService,
  ) {
    this.eventService.subscribeEvents('live-calls', (event, data: any[]) => {
      console.log('live-calls', data);
      const liveCalls = data.map(item => new LiveCallModel(item));

      this.liveCalls.set(liveCalls);
    });
  }

  // Method to get waiting calls for a specific queue
  getWaitingCallsForQueue(queueName: string): LiveCallViewModel[] {
    const states = ['alerting', 'ringing'];
    const newCalls: LiveCallViewModel[] = [];

    this.liveCalls()
      .filter(call => call.account == queueName)
      .forEach(x => {
        const extensions: string[] = x.extension.length > 0 ? x.extension : [];
        if (states.includes(x.state)) {
          for (const extension of extensions) {
            newCalls.push({
              activeCall: x.from,
              startTime: new Date(Number(x.start) * 1000),
              agent: extension,
              id: `${x.id}`,
            });
          }
        } else if (x.state === 'connected' && extensions.length === 0) {
          // For waiting, also include connected calls with no extensions
          newCalls.push({
            activeCall: x.from,
            startTime: new Date(Number(x.start) * 1000),
            agent: '',
            id: `${x.id}`,
          });
        }
      });

    return newCalls;
  }

  // Method to get connected calls for a specific queue
  getConnectedCallsForQueue(queueName: string): LiveCallViewModel[] {
    const states = ['connected'];
    const newCalls: LiveCallViewModel[] = [];

    this.liveCalls()
      .filter(call => call.account == queueName && states.includes(call.state))
      .forEach(x => {
        const extensions: string[] = x.extension.length > 0 ? x.extension : [];
        for (const extension of extensions) {
          newCalls.push({
            activeCall: x.from,
            startTime: new Date(Number(x.start) * 1000),
            agent: extension,
            id: `${x.id}`,
          });
        }
      });

    return newCalls;
  }

  setCurrentQueue(queue: string): void {
    this._currentQueue.set(queue);
  }

  async triggerActiveDomainCalls(): Promise<void> {
    await firstValueFrom(this.apiWallboardService.pbxWallboardTriggerActiveDomainCalls());
  }
}
